import { authHeader, handleConnectionError, handleResponse } from './core';
import { API } from '../constants/';
import { client } from './client';
import { INotificationData, PUSH_TYPE } from 'store/reducers/notifications';

export const sendMessageNotification = (notification: object) => {
  const options: any = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(notification),
  };

  return fetch(`${API}/v2/message/notification`, options)
    .then(handleResponse)
    .then((res) => res)
    .catch(handleConnectionError);
};

// NOTIFICATIONS
export const getNotification = async () => await client.get<undefined, INotificationData[]>('v2/profile/notifications')

export const seenNotification = async (type: PUSH_TYPE, entityId?: string) => await client.put<undefined, INotificationData>(`notifications/${type}/seen?entityId=${entityId}`)